import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accounting-myob-account-codes',
  templateUrl: './accounting-myob-account-codes.component.html',
  styleUrls: ['./accounting-myob-account-codes.component.css']
})
export class AccountingMyobAccountCodesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
